<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Everything you need to build native apps in the cloud securely and at scale'
    "
    [icon]="'@tui.sparkles'"
    [subtitle]="'Key Features'"
    [title]="'Powerful features for cloud builds'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2">
    <!-- Build Stack -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.layers" class="mr-2" />
        <h3 class="text-xl font-bold">Build Stack</h3>
      </div>
      <p class="text-pretty text-lg">
        Optimized build stacks with the latest stable versions of Android
        Studio, Xcode, and Node.js running on macOS M4 Pro instances with up to
        14 CPU cores and 64 GB of RAM for maximum performance.
      </p>
    </div>
    <!-- Git Integration -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.git-branch" class="mr-2" />
        <h3 class="text-xl font-bold">Git Integration</h3>
      </div>
      <p class="text-pretty text-lg">
        Connect any Git provider including GitHub, GitHub Enterprise, GitLab,
        GitLab Self-Managed, Bitbucket, Bitbucket Server, and Azure DevOps.
      </p>
    </div>
    <!-- QR Code App Installation -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.qr-code" class="mr-2" />
        <h3 class="text-xl font-bold">QR Code App Installation</h3>
      </div>
      <p class="text-pretty text-lg">
        Install builds instantly on your device by scanning a QR code. Perfect
        for testing and sharing builds with your team without the hassle of
        copying files or using app stores.
      </p>
    </div>
    <!-- Advanced Configuration -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.settings" class="mr-2" />
        <h3 class="text-xl font-bold">Advanced Configuration</h3>
      </div>
      <p class="text-pretty text-lg">
        Simple capawesome.config.json with support for monorepos, custom build
        commands, and environment variables for maximum flexibility.
      </p>
    </div>
    <!-- Isolated Build Environments -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.shield-check" class="mr-2" />
        <h3 class="text-xl font-bold">Isolated Build Environments</h3>
      </div>
      <p class="text-pretty text-lg">
        Every build runs in its own isolated environment for security and
        consistency. No cross-contamination between builds.
      </p>
    </div>
    <!-- Real-time Build Logs -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.file-text" class="mr-2" />
        <h3 class="text-xl font-bold">Real-time Build Logs</h3>
      </div>
      <p class="text-pretty text-lg">
        Comprehensive, easy-to-read logs streamed in real-time make debugging
        straightforward. Never lose track of what's happening.
      </p>
    </div>
  </div>
</section>
